<template>
  <collapsible-section
      class="collapse-item"
      :id="`objectModelRelationshipsCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
      control-name="objectModelRelationshipsCollapse"
      :is-open="startOpened || isOpen(handler.hasObjectModelRelationshipMatch(lowerQ, objectModel))"
  >
    <template #section-header>
      <row>
        <prefix>
          <icon glyph="relationships"/>
        </prefix>
        <column>
          Relationships
        </column>
      </row>
    </template>
    <template #section-contents>
      <object-model-account-relation-data
        v-if="handler.allowAccountRelationSelection"
        :handler="handler"
        :q="q"
        :object-model="objectModel"
        :level="level + 1"
        default-open
        :path="path"
        :parent-tree-context="computedChildTreeContext"
        @select="select"
        :from-model-view="fromModelView"
      />
      <relation-data
          v-for="relation in objectModelRelations"
          :key="`relation-${relation.client_id}-${dropdownControlId}`"
          :relation="relation"
          :handler="handler"
          :object-model="objectModel"
          :path="path"
          :level="level"
          :q="q"
          @select="select"
          :parent-tree-context="parentTreeContext"
      ></relation-data>
      <relation-data
          v-for="relation in inverseObjectModelRelations"
          :key="`relation-${relation.client_id}-inverse-${dropdownControlId}`"
          :relation="relation"
          inverse
          :handler="handler"
          :object-model="objectModel"
          :path="path"
          :level="level"
          :q="q"
          @select="select"
          :parent-tree-context="parentTreeContext"
      ></relation-data>
    </template>
  </collapsible-section>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import CollapsibleSection from './common/collapsible-section.vue';
import RelationData from './relation-data.vue';
import ObjectModel from "~/models/objectModel";
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
import DynamicElementMixin from './common/dynamic-element-mixin.vue';
import DynamicFieldsHandler from '~/models/dynamicFields/handlers/dynamicFieldsHandler'
import ObjectModelAccountRelationData from '~/components/dynamicFieldsTrees/handlerComponents/object-model-account-relation-data.vue'
import {IDynamicTreeContext} from "~/interfaces/dynamicFieldsInterfaces";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";

export default Vue.extend({
  name: 'object-model-relationship-data',
  mixins: [handlerComponentsMixin, handlerTreeContextMixin, DynamicElementMixin],
  components: {
    CollapsibleSection,
    RelationData,
    ObjectModelAccountRelationData,
  },
  props: {
    handler: {
      // ProcessFlowObjectModelDynamicFieldsHandler | ObjectModelAccountRelationDynamicFieldsHandler
      type: Object as () => DynamicFieldsHandler,
      required: true,
    },
    objectModel: {
      type: Object as () => ObjectModel,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    path: {
      type: Array as () => ReferencePathNode[],
      required: true,
    },
    startOpened: {
      type: Boolean,
      default: false
    },
    fromModelView: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    objectModelRelations(): ObjectModelRelation[] {
      return this.handler.objectModelRelations(this.q, this.objectModel);
    },
    inverseObjectModelRelations(): ObjectModelRelation[] {
      return this.handler.inverseObjectModelRelations(this.q, this.objectModel);
    },
    treeContext(): IDynamicTreeContext {
      return {
        parent: this.objectModel,
        isTopLevelCollectionAssigned: this.parentTreeContext.isTopLevelCollectionAssigned || this.handler.isTopLevelCollection(this.objectModel, this.parentTreeContext),
        referencePathNodesToLevel: this.path,
      }
    },
  }
});
</script>